export default {
    INJECTION_TYPE: {
        Prepend: 1,
        Append: 2,
        Before: 3,
        After: 4,
        Replace: 5
    },
    INJECTION_TYPE_SELECT: [
        {
            id: 1,
            title: "Prepend"
        },
        {
            id: 2,
            title: "Append"
        },
        {
            id: 3,
            title: "Before"
        },
        {
            id: 4,
            title: "After"
        },
        {
            id: 5,
            title: "Replace"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/widgets/helpers/Constants.js